import React from "react";
import BotaoExcluir from "../../common/button/botaoExcluir";
export function TooltipPeriodoTeste({ periodoTeste, item, usuarioLogado, handleClickTooltipPeriodoTeste, handleExcluirPeriodoTeste }) {
    if (!periodoTeste.length) return null;
    const mesInicio = "" + JSON.parse(periodoTeste[0]).mes;
    const anoInicio = "" + JSON.parse(periodoTeste[0]).ano;
    const mesFim = "" + JSON.parse(periodoTeste[periodoTeste.length - 1]).mes;
    const anoFim = "" + JSON.parse(periodoTeste[periodoTeste.length - 1]).ano;
    const inicioTeste = mesInicio + "/" + anoInicio;
    const fimTeste = mesFim + "/" + anoFim;

    const dataAtual = new Date();
    const mesAtual = dataAtual.getMonth() + 1 < 10 ? "0" + (dataAtual.getMonth() + 1) : "" + (dataAtual.getMonth() + 1);
    const anoAtual = "" + dataAtual.getFullYear();
    const competenciaAtual = parseInt(anoAtual + mesAtual);
    const competenciaFimTeste = parseInt(anoFim + mesFim);
    const exibirBotaoExcluirTeste = usuarioLogado.acesso_periodo_teste_demanda_excluir && competenciaAtual > competenciaFimTeste;

    const periodoTesteVigente = competenciaAtual <= competenciaFimTeste;

    return (
        <div
            className={item.alerta_periodo_teste_visualizado || periodoTesteVigente ? "" : "aumentar-diminuir-light"}
            style={{
                backgroundColor: "#257bfb",
                padding: 4,
                borderRadius: "0.3rem",
                fontSize: "0.8rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                width: 190,
                minHeight: `${1.3 * (item.agendamentos.length + 2)}rem`, //+2 pq o tooltip teste tem 2 linhas
                margin: 3,
            }}
        >
            <div
                style={{
                    margin: 0,
                    display: "flex",
                    justifyContent: exibirBotaoExcluirTeste ? "flex-end" : "center",
                    flexGrow: 1,
                    cursor: item.alerta_periodo_teste_visualizado || periodoTesteVigente ? "default" : "pointer",
                }}
                onClick={() => {
                    if (item.alerta_periodo_teste_visualizado || periodoTesteVigente) return;
                    handleClickTooltipPeriodoTeste(item);
                }}
            >
                <u>
                    <b>{`Período de Testes ativo: `}</b>
                </u>
            </div>
            {exibirBotaoExcluirTeste ? (
                <BotaoExcluir
                    event={() => {
                        handleExcluirPeriodoTeste(item);
                    }}
                />
            ) : null}
            <div
                style={{
                    margin: 0,
                    textAlign: "center",
                    minWidth: "100%",
                    cursor: item.alerta_periodo_teste_visualizado || periodoTesteVigente ? "default" : "pointer",
                }}
                onClick={() => {
                    if (item.alerta_periodo_teste_visualizado || periodoTesteVigente) return;
                    handleClickTooltipPeriodoTeste(item);
                }}
            >{`Início ${inicioTeste} - Fim ${fimTeste}`}</div>
        </div>
    );
}
